/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    message?: string;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    displayOnWebsite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    displayOnInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    courierSettingsId?: number;
}

/**
 * Check if a given object implements the Notification interface.
 */
export function instanceOfNotification(value: object): value is Notification {
    return true;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'message': json['message'] == null ? undefined : json['message'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'displayOnWebsite': json['displayOnWebsite'] == null ? undefined : json['displayOnWebsite'],
        'displayOnInvoice': json['displayOnInvoice'] == null ? undefined : json['displayOnInvoice'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierSettingsId': json['courierSettingsId'] == null ? undefined : json['courierSettingsId'],
    };
}

export function NotificationToJSON(json: any): Notification {
    return NotificationToJSONTyped(json, false);
}

export function NotificationToJSONTyped(value?: Notification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'message': value['message'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'displayOnWebsite': value['displayOnWebsite'],
        'displayOnInvoice': value['displayOnInvoice'],
        'id': value['id'],
        'courierSettingsId': value['courierSettingsId'],
    };
}

